import { findInputRadioByText, getFieldDescription, getInputsSelector, getNativeFieldType, getRadioElementAllowedValues, getSelectElementAllowedValues, isCustomInput, isHidden, isRadioElement, isNativeFormControl, setFormElementValueWithEvents } from './utils';
export class KendoSmartPaste {
    constructor(options) {
        this.options = options;
    }
    get formElement() {
        const element = this.options.getElement();
        return element?.closest('form') ?? null;
    }
    populateFormFields(response, formConfig) {
        if (!response.fieldValues) {
            return;
        }
        formConfig.forEach((formField) => {
            const fieldValues = response.fieldValues, rawValue = fieldValues[formField.field];
            if (rawValue === undefined || rawValue === null) {
                return;
            }
            let stringValue;
            if (typeof rawValue === 'string') {
                stringValue = rawValue;
            }
            else if (typeof rawValue === 'number' || typeof rawValue === 'boolean') {
                stringValue = String(rawValue);
            }
            else {
                // Placeholder for handling complex objects, arrays, etc.
                // This codepends on whether or not the AI service will be altered/enhanced.
                return;
            }
            const trimmedValue = stringValue.trim();
            this.populateFormField(formField, trimmedValue);
        });
    }
    extractFormConfig() {
        if (!this.formElement) {
            return [];
        }
        const fields = [], inputsSelector = getInputsSelector(this.options.customInputs), elements = Array.from(this.formElement.querySelectorAll(inputsSelector));
        for (const element of elements) {
            let field = null;
            const isCustomInputElement = isCustomInput(element, this.options);
            if (isNativeFormControl(element) && !isCustomInputElement) {
                if (isHidden(element)) {
                    continue;
                }
                field = this.processNativeFormControl(element);
            }
            else if (isCustomInputElement) {
                field = this.processCustomInput(element, fields);
            }
            if (field) {
                fields.push(field);
            }
        }
        return fields;
    }
    populateFormField(formField, value) {
        const isRadio = isRadioElement(formField.element);
        if (isRadio) {
            const element = formField.element, radioInput = findInputRadioByText(this.formElement, element.name, value);
            if (radioInput) {
                setFormElementValueWithEvents(radioInput, true);
            }
        }
        else if (formField.type === 'kendo-input') {
            if (this.options.setKendoInputValue) {
                this.options.setKendoInputValue(formField, value);
            }
        }
        else {
            setFormElementValueWithEvents(formField.element, value);
        }
    }
    processNativeFormControl(element) {
        const isRadio = isRadioElement(element);
        const identifier = element.name || element.id;
        if (!identifier) {
            return null;
        }
        if (!isRadio) {
            const description = getFieldDescription(this.formElement, element);
            if (!description) {
                return null;
            }
        }
        const baseField = {
            field: identifier,
            description: isRadio ? null : getFieldDescription(this.formElement, element),
            element,
            type: getNativeFieldType(element)
        };
        if (element instanceof HTMLSelectElement) {
            return {
                ...baseField,
                allowedValues: getSelectElementAllowedValues(element)
            };
        }
        if (isRadio) {
            return {
                ...baseField,
                allowedValues: getRadioElementAllowedValues(identifier, this.formElement)
            };
        }
        return baseField;
    }
    processCustomInput(element, existingFields) {
        const field = element.id || element.getAttribute('name') || '', isDuplicate = existingFields.some((existingField) => existingField.field === field && existingField.element === element);
        if (!isDuplicate && this.options.getSmartPasteField) {
            const description = getFieldDescription(this.formElement, element, true);
            const smartPasteField = {
                field,
                description,
                element,
                type: 'kendo-input'
            };
            return this.options.getSmartPasteField(smartPasteField) || null;
        }
        return null;
    }
}
